import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from '@/store/auth';
import { useToast } from 'vue-toastification';
import { ref, computed } from 'vue';
import PasswordInput from './password.vue';
import DotDotDot from '../DotDotDot.vue';
import { isMobile } from '../Navbar/navState';
import router from "@/router";

type Emits ={
	(e: 'moveToSignup'):void,
	(e: 'done'):void,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  emits: ["moveToSignup", "done"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const email = ref("");
const password = ref("");

const toast = useToast();

const error = ref<null | string>(null);
const loading = ref(false);

const auth = useAuth();

const errorMap: Record<string, string> = {
	'auth/invalid-login-credentials': 'invalid username or password'
};

const performSignin = async () => {
	error.value = null;
	loading.value = true;

	const res = await auth.signIn(email.value, password.value);

	loading.value = false;
	if(res.success) {
		router.push('/');
		toast(`Signed in with ${email.value}`);
		emit('done');
	} else {

		// eslint-disable-next-line no-lonely-if
		if(errorMap?.[res.reason || '']){
			error.value = errorMap[res.reason as string || ''];
		}else{
			error.value = res.reason!;
		}
	}
};
const passResetMessage = ref<string | null>(null);
const passResetWaiting = ref(false);
const performPasswordReset = async () => {
	console.log("Doing password reset");
	if(!email.value) {
		passResetMessage.value = "Please type in your email first";
		return;
	}
	
	passResetMessage.value = null;
	passResetWaiting.value = true;

	try {
		await auth.sendPasswordReset(email.value);
	} catch (e) {
		// Oops
	} finally {
		passResetMessage.value = "Password reset email sent! Be sure to check your spam folder.";
		passResetWaiting.value = false;
	}


};
const check = () => {
	console.log("clicked!");
};


const buttonDisabled = computed(()=>{
	if(email.value.length > 3 && password.value.length > 3) {
		return false;
	}else{
		return true;
	}
});;

const __returned__ = { emit, email, password, toast, error, loading, auth, errorMap, performSignin, passResetMessage, passResetWaiting, performPasswordReset, check, buttonDisabled, get useAuth() { return useAuth }, get useToast() { return useToast }, ref, computed, PasswordInput, DotDotDot, get isMobile() { return isMobile }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})